import React from "react";
import styles from '../styles/invite.module.scss'
import InviteInfo from "./inviteInfo";
import EventDetails from "./eventDetails";
import FadeIn from "@/compoments/fadeIn";
import { useTranslation } from "react-i18next";

const Invite = ({currentIndex, invitePrizeData, baseConfigData, prizeConfigData}) => {
  const { t } = useTranslation('inviteFriends')
  const rulesList = baseConfigData?.list?.[0]
  
  const infoList = [
    {
      content: invitePrizeData?.registeredNumTotal,
      title: t('invite.inviteRegister'),
    },
    {
      content: invitePrizeData?.bonusAmountTotal,
      title: t('invite.getInviteBonus'),
    },
    {
      content: invitePrizeData?.successNumTotal,
      title: t('invite.inviteSuccess'),
    },
  ]
  

  return (
    <FadeIn>
    <div className={styles.invite}>

      {/* 图片 推荐链接等 */}
      <InviteInfo list={infoList} />

      {/* 活动内容 */}
      <EventDetails rulesList={rulesList} currentIndex={currentIndex} prizeConfigData={prizeConfigData} />
      
    </div>
    </FadeIn>
  )
}

export default Invite